import React, { useState, useEffect, Fragment } from 'react'
import { Grid } from '@material-ui/core'

import CampaignPage from 'Containers/Campaigns/Page'
import { CityPlansWrapper } from 'Components/Campaigns/Page/CityPlans/CityPlansWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { ToggleButton } from 'Components/Form/ToggleButton'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import { apiClient as API } from 'Module/API/Client'
import { urlGet } from 'Utils/URL'
import getBonusResultsData from './gql'
import SummaryView from './component/SummaryView'
import DetailedView from './component/DetailedView'

const viewOptions = [
  { label: 'Detailed View', value: 'detailed' },
  { label: 'Summary', value: 'summary' },
]

const BonusResults = props => {
  const {
    match: {
      params: { campaignId },
    },
  } = props

  const urlValue = urlGet('View')

  const [state, setState] = useState({
    cities: [],
    citiesOptions: [],
    bonusResults: {},
    loading: true,
    view: urlValue ? urlValue : viewOptions[0].value,
  })

  const { currency } = state.bonusResults

  const formatCurrency = amount => `${currency}${amount}`

  useEffect(() => {
    const getInitialData = async () => {
      const { campaignId } = props.match.params
      const { data } = await getBonusResultsData(campaignId)
      const cityPlans = data.campaign.cityPlans.nodes
      const cities = cityPlans.map(({ city }) => city)
      const citiesOptions = cities.map(city => ({
        label: city.name,
        value: city.id,
      }))
      citiesOptions.push({
        label: 'All',
        value: null,
      })

      const bonusResponse = await API.getBonusResults(campaignId)
      const bonusResults = await bonusResponse.json()

      setState(state => ({
        ...state,
        cities,
        citiesOptions,
        bonusResults,
        selectedCity: citiesOptions[0] ? citiesOptions[0].value : null,
        loading: false,
      }))
    }
    getInitialData()
  }, [])

  return (
    <CampaignPage
      active={props.nav}
      campaignId={campaignId}
      match={props.match}
      history={props.history}
    >
      <CityPlansWrapper>
        <LayoutDashboard>
          {state.loading ? (
            <LoadingIndicator />
          ) : (
            <Fragment>
              <Grid container>
                <Grid item>
                  <ToggleButton
                    value={state.view}
                    options={viewOptions}
                    onChange={value =>
                      setState(state => ({ ...state, view: value }))
                    }
                    url={'View'}
                  />
                </Grid>
              </Grid>
              {state.view === 'detailed' ? (
                <DetailedView data={state} formatCurrency={formatCurrency} />
              ) : (
                <SummaryView data={state} formatCurrency={formatCurrency} />
              )}
            </Fragment>
          )}
        </LayoutDashboard>
      </CityPlansWrapper>
    </CampaignPage>
  )
}

export default BonusResults
